var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.experience && _vm.isDisabled
        ? _c("div", [
            _c("div", { staticClass: "text-danger text-small" }, [
              _c("i", { staticClass: "fas fa-exclamation-circle" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "message.booking.checkout_step.service_provider_cannot_travel"
                    )
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-danger pb-3 text-small" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("message.booking.checkout_step.please_contact_admin")
                  ) +
                  " \n        "
              ),
              _c(
                "a",
                {
                  staticClass: "text-primary-link",
                  attrs: {
                    href: "https://line.me/R/ti/p/%40hnk7011n",
                    target: "_blank"
                  }
                },
                [_vm._v("Line @BeNeat")]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block btn-outline-info btn-sm",
                on: {
                  click: function($event) {
                    return _vm.openUnavailableServiceAreaModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.booking.checkout_step.view_more")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))])
      ]),
      _vm._v(" "),
      Number(_vm.bookingData.service_id) === 1 && _vm.bookingData.place_size_id
        ? _c("div", { staticClass: "p-2" }, [
            _c("div", [_c("b", [_vm._v(_vm._s(_vm.bookingData.place_name))])]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm._f("multiLangName")(
                    _vm.$t(
                      _vm.globalState.placeSizes[
                        Number(_vm.bookingData.place_size_id)
                      ]
                    )
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-primary" }, [
              _vm._v(
                _vm._s(_vm.$t("message.booking.booking_step.recommend")) +
                  " " +
                  _vm._s(
                    _vm.$t(
                      _vm.globalState.durations[
                        Number(_vm.bookingData.place_size_id)
                      ]
                    )
                  ) +
                  "\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row no-gutters mt-2" },
        _vm._l(_vm.message.buttons, function(button) {
          return _c("div", { staticClass: "col-4 p-1" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-outline-info btn-block btn-small-group text-center",
                attrs: { disabled: _vm.isDisabled },
                on: {
                  click: function($event) {
                    return _vm.sendMessage(button)
                  }
                }
              },
              [_vm._v(_vm._s(button.text) + "\n        ")]
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-362cc271", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362cc271","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/ButtonsMessage.vue
// module id = 2090
// module chunks = 0